import { render, staticRenderFns } from "./PaymentReportData.vue?vue&type=template&id=222acd52"
import script from "./PaymentReportData.vue?vue&type=script&lang=js"
export * from "./PaymentReportData.vue?vue&type=script&lang=js"
import style0 from "./PaymentReportData.vue?vue&type=style&index=0&id=222acd52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports